module.exports = __webpack_public_path__ + "img/logo-test-white.9d472079.png";